import React, { ComponentPropsWithoutRef, FC } from 'react';
import cn from 'classnames';

const RemoveButton: FC<ComponentPropsWithoutRef<'button'>> = (props) => (
  <button
    {...props}
    title="Remove from cart"
    data-cy="remove"
    className={cn(
      props.className,
      'ml-20 flex items-center justify-center bg-none border-none text-grey-1',
      !props.disabled &&
        'cursor-pointer hover:text-grey-2 focus:text-grey-1 transition-all duration-100',
    )}
  >
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.41401 8.00001L15.707 1.70701C16.098 1.31601 16.098 0.684006 15.707 0.293006C15.316 -0.0979941 14.684 -0.0979941 14.293 0.293006L8.00001 6.58601L1.70701 0.293006C1.31601 -0.0979941 0.684006 -0.0979941 0.293006 0.293006C-0.0979941 0.684006 -0.0979941 1.31601 0.293006 1.70701L6.58601 8.00001L0.293006 14.293C-0.0979941 14.684 -0.0979941 15.316 0.293006 15.707C0.488006 15.902 0.744006 16 1.00001 16C1.25601 16 1.51201 15.902 1.70701 15.707L8.00001 9.41401L14.293 15.707C14.488 15.902 14.744 16 15 16C15.256 16 15.512 15.902 15.707 15.707C16.098 15.316 16.098 14.684 15.707 14.293L9.41401 8.00001Z"
        fill="currentColor"
      />
    </svg>
  </button>
);

export default RemoveButton;
